import React from 'react';
import './FirstSection.css';

const FirstSection = () => {
  return (
    <section className="first-section">
      <div className="content">
        <div className="image">
          <h2>Freddy Krueger</h2>
          <a href="https://pump.fun" target='_blank' rel="noopener noreferrer">
            <div className='image-container' />
          </a>
          <h3>Now SOL can't sleep, Welcome To My Nightmare.</h3>
        </div>
      </div>
    </section>
  );
};

export default FirstSection;
